"use strict";
/*
 * For:
 *    tracking clicks on static links to the iPaper domain or links to a file
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.iPaperLinkComponent = exports.FileLinkCheckerComponent = void 0;
const app_1 = require("app");
class FileLinkCheckerComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = 'a';
    }
    OnInit() {
        // skip code execution if dataLayer is not set
        if (!(0, app_1.isDataLayerSet)()) {
            return;
        }
        this.iPaperDomain = app_1.ConfigService.GetIPaperDomain();
        this.el.forEach((el) => {
            this.currentLink(el);
        });
    }
    currentLink(el) {
        const href = el.getAttribute('href');
        const title = el.textContent || el.innerText;
        if (!title || !href || href === '#') {
            return;
        }
        if (href.indexOf(this.iPaperDomain) !== -1) {
            el.addEventListener('click', () => {
                app_1.GTM.iPaper({
                    name: title,
                    url: href,
                });
            });
        }
        else if (app_1.UrlService.isUrlToFile(href, true)) {
            el.addEventListener('click', ev => {
                const linkTarget = el.getAttribute('target');
                const gtmData = {
                    name: title,
                    page: window.location.href,
                    path: href,
                    type: app_1.UrlService.GetFileExtension(href),
                };
                if (linkTarget !== '_blank') {
                    ev.preventDefault();
                    return app_1.GTM.download(gtmData, () => {
                        window.location.href = href;
                    });
                }
                app_1.GTM.download(gtmData);
            });
        }
    }
}
exports.FileLinkCheckerComponent = FileLinkCheckerComponent;
exports.iPaperLinkComponent = new FileLinkCheckerComponent();
